import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import { store } from "../../index";
import { lang } from '@/boot/i18n';
import { makeScreen } from "./_utils";
export default {
  type: 'demographics',
  requiresTransaction: false,

  /**
   * Determines if a Demographics question should be added to the selection
   *
   * @param {Object} context
   *
   * @returns {Boolean} true if the question should be added to the selection, else false.
   */
  select: function () {
    var _select = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", true);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function select() {
      return _select.apply(this, arguments);
    }

    return select;
  }(),

  /**
   * Renders a Demographics Screen
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      var demographics, questions;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // get demographics and bail if none available
              demographics = store.getters['config/getDemographics'];

              if (!(!Array.isArray(demographics) || demographics.length < 1)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", null);

            case 3:
              // prepare array of demographics questions
              questions = demographics.map(function (demographic, i) {
                var uiProperties = null;

                if (demographic.fieldType == 'select') {
                  var demographicOptions = Array.isArray(demographic.options) ? demographic.options : []; // if there's no options to chose from, we shouldn't render this demographics because it'll look silly!

                  if (!demographicOptions.length) {
                    return null;
                  }

                  var options = demographicOptions.map(function (demographicOption, j) {
                    return {
                      id: 'section.name' + i + 'demographicOption' + j,
                      label: demographicOption.value,
                      val: demographicOption.id
                    };
                  });
                  uiProperties = {
                    type: 'fib-select-option',
                    props: {
                      center: true,
                      multiple: false,
                      options: options
                    }
                  };
                } else if (demographic.fieldType == 'text') {
                  uiProperties = {
                    type: 'fib-comments',
                    props: {
                      center: true,
                      multiple: false,
                      isPostcodeField: true
                    }
                  };
                }

                if (!uiProperties) {
                  return null;
                }

                return _objectSpread(_objectSpread({}, uiProperties), {}, {
                  id: context.section.name + i,
                  required: context.section.required,
                  label: demographic.label,
                  _meta: {
                    demographic: demographic
                  }
                });
              }).filter(function (d) {
                return d;
              }); // Ignore anything we null out from

              return _context2.abrupt("return", makeScreen(context, questions, {
                title: lang('demographics_header')
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function render(_x) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    var demographics = context.response;

    if (!demographics.length) {
      return null;
    }

    return {
      demographics: demographics,
      mutateSubmit: function mutateSubmit(submit) {
        submit.demographics = this.demographics.map(function (d) {
          return {
            id: d.meta.demographic.id,
            value: d.value
          };
        });
      }
    };
  }
};